import { Popover as PopoverNative } from 'antd';
import { PopoverProps } from 'antd/es/popover';
import React from 'react';

const titleStyle = {
  margin: 0,
  padding: `6px 5px`,
  color: `rgba(0, 0, 0, 0.85)`,
  fontWeight: 500,
  fontSize: 16,
  lineHeight: `22px`,
  wordWrap: 'break-word',
} as const;

type Props = {
  footer?: React.ReactNode;
  title?: React.ReactNode;
  content?: React.ReactNode;
} & PopoverProps;

export default ({ title, content, footer, ...popoverProps }: Props) => {
  return (
    <PopoverNative
      title={<div style={{ ...titleStyle }}>{title}</div>}
      content={
        <div>
          {content}
          {footer ? <div>{footer}</div> : null}
        </div>
      }
      getPopupContainer={v => v.offsetParent as HTMLElement}
      {...popoverProps}
    />
  );
};
